import api from './api';

const BASE_PATH = '/admin/learning_paths';

/**
 * Cliente da API admin de trilhas (LearningPath).
 * Backend em backend/app/controllers/api/v1/admin/learning_paths_controller.rb.
 */
export const adminLearningPathsApi = {
  index: () => api.get(BASE_PATH),

  // body flat: { name, description, active, position }
  update: (id, payload) => api.patch(`${BASE_PATH}/${id}`, payload),

  // Alunos que iniciaram a trilha. Fixa: 1 linha por UserLearningPath; adaptativa: 1 linha por aluno
  // (type learning_path_student_group, id = id do aluno).
  // Filtros de GRE/instituição/curso/turma: um id cada, vazio = sem filtro.
  students: (id, { q = '', page = 1, perPage = 25, regionalId, institutionId, courseId, classroomId } = {}) =>
    api.get(`${BASE_PATH}/${id}/students`, {
      params: {
        q: q || undefined,
        page,
        per_page: perPage,
        regional_id: regionalId || undefined,
        institution_id: institutionId || undefined,
        course_id: courseId || undefined,
        classroom_id: classroomId || undefined
      }
    }),

  // Trilha adaptativa: trilhas de um aluno (1 linha por UserLearningPath).
  studentTrails: (id, userId, { page = 1, perPage = 25 } = {}) => api.get(`${BASE_PATH}/${id}/students`, { params: { user_id: userId, page, per_page: perPage } }),

  // Progresso por capítulos (adaptativas) ou seções (fixas).
  studentDetail: (userLearningPathId, grouping) => api.get(`/admin/user_learning_paths/${userLearningPathId}`, { params: { group_by: grouping } }),

  // Desempenho do aluno na trilha inteira: áreas → matérias → descritores.
  studentPerformance: userLearningPathId => api.get(`/admin/user_learning_paths/${userLearningPathId}/performance`)
};

export default adminLearningPathsApi;
